module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki09_sp-61d0d47a32e737d0b086f8ae489e5aee.jpg";